import { z } from "zod";

import { SiteControllerSettingTemairazuInputSchema } from "@/lib/zod/__generated__/validation-schema";

export const siteControllerSettingTemairazuInputZodSchema = SiteControllerSettingTemairazuInputSchema.extend({
	password: z.string().min(1, { message: "パスワードは必須入力です" }).max(500),
});

export type SiteControllerSettingTemairazuInputZodSchemaType = z.infer<
	typeof siteControllerSettingTemairazuInputZodSchema
>;
